export const CRM_SUPPLIER_FORM_FIELD_DEFAULTS = {
  name: true,
  phone: true,
  email: false,
  address: true,
  city: false,
  state: false,
  zip_code: false,
  country: false,
  tax_id: false,
  vat_number: true,
  notes: true
}

export const CRM_SUPPLIER_FORM_FIELD_LABELS = {
  name: 'label',
  phone: 'phone',
  email: 'email',
  address: 'address',
  city: 'city',
  state: 'state',
  zip_code: 'zip_code',
  country: 'country',
  tax_id: 'tax_id',
  vat_number: 'vat_number',
  notes: 'notes'
}

export function getCrmSupplierFormFieldDefaults() {
  return { ...CRM_SUPPLIER_FORM_FIELD_DEFAULTS }
}
